import type { DxpError } from './dxp-error';
import type { ErrorRecovery } from './user-facing-error.model';

export interface RecoverableError {
  readonly recovery: ErrorRecovery;
}

export function isRecoverable(error: unknown): error is DxpError & RecoverableError {
  return (
    error instanceof Error &&
    'recovery' in error &&
    typeof (error as { recovery?: unknown }).recovery === 'object' &&
    (error as { recovery?: unknown }).recovery !== null
  );
}
